import React from 'react'

const TeleportNft = () => {
  return (
    <div>
      <h1>
      this is TeleportNft </h1>
    </div>
  )
}

export default TeleportNft
